import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios  from 'axios';

export default function PostAdd(props) {
  const [text, setText] = useState("");

  const submitPost = (event) => {

    Axios.post(
        "api/Community/AddPost",
        {
            CourseNum: props.crsnum,
            Message: text
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then(function(response) {
          console.log(response);
          setText('')
      props.postAdded()
        })
        .catch(function(error) {
          console.log(error);
        });
      event.preventDefault();
  };

  return (
    
    <li>
      
      <div class="timeline-body">
        <h4>Add New Post</h4>
        <div class="input">
          <form action="">
            <div class="input-group">
              <textarea
                type="text"
                class="form-control "
                onChange={event => setText(event.target.value)}
                placeholder="Write a Post..."
                value={text}
              >
      
              </textarea>
              <div class="input-group-append">
                <button type="button" class="btn btn-primary" onClick={submitPost}>
                  <i class="fab fa-lg fa-fw  fa-telegram-plane" />
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Community/PostAdd.js